import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();

  if (!ready) {
    return (
      <div className="min-h-screen bg-[#111827] flex items-center justify-center">
        <p className="font-mono-kds text-[#9CA3AF] text-sm tracking-widest animate-pulse">
          LOADING KITCHEN…
        </p>
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
